<div class="notification-menu" *ngIf="notifications$ | async as notifications">
    <mat-menu #notificationMenu="matMenu" [overlapTrigger]="false" [xPosition]="'before'" class="notification-menu__panel">
        <div (click)="$event.stopPropagation()">
            <div *ngIf="notifications.length === 0" class="notification-menu__notification">
                <div class="notification-menu__notification__title">
                    <mat-icon svgIcon="information-outline" class="syn-text--info"></mat-icon>
                    <span class="syn-text--info">Information :</span>
                    &nbsp;
                    Ceci est votre liste de notification.
                </div>
                <div class="notification-menu__notification__details">
                    Elle est actuellement vide et vous affichera les 10 dernières notifications.
                </div>
            </div>
            <div *ngFor="let notification of notifications" class="notification-menu__notification">

                <div class="mat-body-1" fxLayout="row">
                    <ng-container *ngIf="notification.type === 'danger'">
                        <mat-icon class="syn-text--danger" svgIcon="alert-circle-outline"></mat-icon>
                        <span class="syn-text--danger">Erreur :</span>
                    </ng-container>
                    <ng-container *ngIf="notification.type === 'warning'">
                        <mat-icon class="syn-text--warning" svgIcon="alert-outline"></mat-icon>
                        <span class="syn-text--warning">Alerte :</span>
                    </ng-container>
                    <ng-container *ngIf="notification.type === 'info'">
                        <mat-icon class="syn-text--info" svgIcon="information-outline"></mat-icon>
                        <span class="syn-text--info">Information :</span>
                    </ng-container>
                    <ng-container *ngIf="notification.type === 'success'">
                        <mat-icon class="syn-text--success" svgIcon="check-circle-outline"></mat-icon>
                        <span class="syn-text--success">Validation :</span>
                    </ng-container>

                    &nbsp;

                    <div>
                        {{ notification.title }}
                    </div>
                </div>

                <div class="mat-caption">
                    {{ notification.description }}
                </div>
                <div *ngIf="isArray(notification.meta);then array else string"></div>
                    <ng-template #array>
                        <div class="meta">
                        <ul>
                                <li *ngFor="let m of notification.meta">{{ m.field }}: {{ m.message }}</li>
                            </ul>
                        </div>
                    </ng-template>
                    <ng-template #string>
                        <div class="meta">
                            {{ notification.meta }}
                        </div>
                    </ng-template>
                <div fxLayoutAlign="start center" *ngIf="notification.correlationId" class="notification-menu__notification__details">
                    <span>CorrelationId (identifiant de l'erreur): {{ notification.correlationId }}</span>
                    <button matTooltip="Copier l'identifiant de l'erreur dans le presse papier." mat-icon-button [synCopyToClipboard]="notification.correlationId">
                        <mat-icon class="notification-menu__copy" matButton svgIcon="clipboard-outline"></mat-icon>
                    </button>
                </div>


                <hr />

            </div>
        </div>
    </mat-menu>
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu">
        <mat-icon
            [matBadge]="notifications.length"
            [matBadgeHidden]="notifications.length <= 0"
            matBadgePosition="above after"
            matBadgeSize="medium"
            matBadgeColor="accent"
            [svgIcon]="notifications.length ? 'bell' : 'bell-outline'">
        </mat-icon>
    </button>
</div>
